import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import NewsListPage from "../pages/news/page";
import FilmDetailPage from "../pages/detail/film/page";
import NewsDetailPage from "../pages/detail/news/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import FavoritesPage from "../pages/favorites/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:type", element: <CategoryPage /> },
      { path: "/news/:category", element: <NewsListPage /> },
      { path: "/detail/film/:id", element: <FilmDetailPage /> },
      { path: "/detail/news/:id", element: <NewsDetailPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/contact", element: <ContactPage /> },
      { path: "/favorites", element: <FavoritesPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;